import React from 'react';
import { dateObj, dayStatus, fmtMonth, monthEnd, monthStart, rangeDays, STATUS_STYLE } from './calUtils';

const WEEK = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const DayCard = ({ room, iso, onPick }) => {
  const d = room.days[iso];
  const booked = room.booked[iso] || 0;
  const st = dayStatus(d, booked, room.units);
  return (
    <button type="button" onClick={() => onPick(room, iso, 'price')} className="h-20 rounded border bg-white hover:ring-2 hover:ring-[#003b95] text-left p-1.5 flex flex-col" data-testid={`rc-month-${room.room_id}-${iso}`}>
      <span className="flex items-center justify-between text-[10px] text-slate-500"><span>{iso.slice(8, 10)}</span><span className={`w-2 h-2 rounded-full ${STATUS_STYLE[st].split(' ')[0]}`} /></span>
      <span className="text-sm font-bold text-slate-900 mt-auto">{d?.price1 != null ? `€${Math.round(d.price1)}` : '—'}</span>
      <span className="text-[10px] text-slate-600">{d ? `${d.numAvail ?? '?'} to sell · ${booked} booked` : 'no rate'}</span>
    </button>
  );
};

// Booking.com "Monthly view": one room, a 7-column month grid, each day = price / rooms to sell / booked.
export const MonthView = ({ room, start, onPick }) => {
  const first = monthStart(start);
  const days = rangeDays(first, monthEnd(start));
  const lead = (dateObj(first).getUTCDay() + 6) % 7;
  const blanks = Array.from({ length: lead }, (_, i) => <div key={`b${i}`} />);
  const cards = days.map((iso) => <DayCard key={iso} room={room} iso={iso} onPick={onPick} />);
  const heads = WEEK.map((w) => <div key={w} className="text-[10px] font-semibold text-slate-500 text-center">{w}</div>);
  return (
    <div data-testid="rc-month-view">
      <p className="text-sm font-bold text-slate-900 mb-2">{room.room} <span className="text-xs text-slate-500 font-normal">· {fmtMonth(first)} · Room ID {room.room_id}</span></p>
      <div className="grid grid-cols-7 gap-1">{heads}{blanks}{cards}</div>
    </div>
  );
};
